import { Flex, Text } from "@chakra-ui/react";
import React, { Suspense, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Header from "../../components/Header";
import { baseURL } from "../../services/api";
import { FiltroPedidos } from "../Devolucoes/FiltroPedidos";
import { Table } from "./Table/Table";

export default function CreditoPedido() {
  const [infos, setInfos] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  async function submitForm(data) {
    console.log(data);
    setLoading(true);
    try {
      const response = await baseURL.post("/pedido/lista-pedidos-creditos", data);
      setInfos(response.data);

      console.log(response.data);
      setLoading(false);
    } catch (error) {
      console.log(Object.keys(error), error.message);
      setLoading(false);
    }
  }

  useEffect(() => {
    submitForm({ pendente: "" });
  }, []);

  return (
    <>
      <Flex flexDir="column">
        <Text paddingBlock="2rem" bg="#378BBF" textAlign="center" fontSize="1.2rem" color="white" fontWeight="bold">
          Crédito de Pedidos
        </Text>
        <FiltroPedidos
          register={register}
          handleSubmit={handleSubmit}
          submitForm={submitForm}
          errors={errors}
          isSubmitting={isSubmitting}
        />
        <Suspense fallback={<div>Carregando...</div>}>
          <Table data={infos} isSubmitting={isSubmitting} />
        </Suspense>
      </Flex>
    </>
  );
}
